/** The open event object itself, straight from the app's store (GetEvent shape:
 *  Id, HT/AT, EHT/EAT, CN/ECN, SN/ESN, CtN/ECtN, D). Null in the lobby or when
 *  the store is not there. Same fail-closed reading as appOpenEventId. */
export function appOpenEvent(w?: unknown): Record<string, unknown> | null {
  try {
    const win = (w ?? (typeof window !== "undefined" ? window : null)) as {
      sportdigi?: { mobile?: { store?: { getState?: () => unknown } } };
    } | null;
    const state = win?.sportdigi?.mobile?.store?.getState?.() as {
      eventDetails?: { eventList?: unknown };
    } | undefined;
    const ev = state?.eventDetails?.eventList;
    if (!Array.isArray(ev) || ev.length === 0) return null;
    const first = ev[0];
    if (!first || typeof first !== "object") return null;
    const id = String((first as { Id?: unknown }).Id ?? "");
    return /^\d{5,12}$/.test(id) ? (first as Record<string, unknown>) : null;
  } catch {
    return null;
  }
}

export function appOpenEventId(w?: unknown): string | null {
  try {
    const win = (w ?? (typeof window !== "undefined" ? window : null)) as {
      sportdigi?: { mobile?: { store?: { getState?: () => unknown } } };
    } | null;
    const state = win?.sportdigi?.mobile?.store?.getState?.() as {
      eventDetails?: { eventList?: unknown };
    } | undefined;
    const ev = state?.eventDetails?.eventList;
    if (!Array.isArray(ev) || ev.length === 0) return null;
    const first = ev[0] as { Id?: unknown } | null;
    if (!first || typeof first !== "object") return null;
    const id = String(first.Id ?? "");
    return /^\d{5,12}$/.test(id) ? id : null;
  } catch {
    return null;
  }
}

/** Is the app's store there to be asked at all? True when `eventDetails.eventList`
 *  is an array — empty in the lobby, populated on a match page (measured live
 *  2026-08-31 and 2026-09-09). When it is, an EMPTY list is the answer "lobby",
 *  and the net/DOM readers must not overrule it. */
export function appStoreReachable(w?: unknown): boolean {
  try {
    const win = (w ?? (typeof window !== "undefined" ? window : null)) as {
      sportdigi?: { mobile?: { store?: { getState?: () => unknown } } };
    } | null;
    const state = win?.sportdigi?.mobile?.store?.getState?.() as {
      eventDetails?: { eventList?: unknown };
    } | undefined;
    return Array.isArray(state?.eventDetails?.eventList);
  } catch {
    return false;
  }
}
